import type { RecipeDto } from "@strtmn/sds/types"
import { useContext } from "react"
import { FaBook } from "react-icons/fa6"
import { useParams } from "react-router-dom"
import config from "../../../config"
import { UserDataContext, UserDataContextHelper } from "../../../contexts"
import { ListPage } from "../-components/ListPage"
import RecipeItem from "../-components/RecipeItem"

import "../RecipeManagement.css"

export default function Recipes() {
  const params = useParams()
  const { userData } = useContext(UserDataContext)
  const org = UserDataContextHelper.findOrg(params["orgId"]!, userData!)
  const recipes = UserDataContextHelper.findRecipes(org)

  return (
    <>
      <ListPage
        _className="recipes"
        icon={<FaBook className="w-5 _h-3.5_ relativ text-[#3E9E29]" />}
        title="Rezepte"
        items={recipes.sort((a, b) =>
          a.name.localeCompare(b.name, undefined, {
            sensitivity: "base",
            numeric: true,
          })
        )}
        maxNumItems={config.limits.numberOfRecipes}
        renderFunc={(item: RecipeDto) => (
          <RecipeItem key={item.id} org={org} item={item} hasEditButton />
        )}
      />

      {/* <small>* Die Icons "book-blank", "sliders-up", "eye (light)" benötigen FontAwesome Pro, kostet 49,- oder 99,- pro Jahr.</small> */}
    </>
  )
}
